import React, {Fragment, useContext, useState} from "react";
import {CustomerTypeContext, isCustomerCompany} from "../../../context/customer-type-context";
import FormatUtils from "../../../utils/FormatUtils";
import LabelWithInfo from "../../../components/LabelWithInfo/LabelWithInfo";

function CreditCalculationSummary(props) {

    const customerContext = useContext(CustomerTypeContext);
    const isCompany = isCustomerCompany(customerContext);
    const [expanded, setExpanded] = useState(false);
    const productNoun = props.productNoun || "kredytu";

    const insuranceAmount = props.insuranceData
        ? (isCompany ? props.insuranceData.companyInsurance : props.insuranceData.consumerInsurance)
        : null;
    const insuranceSuffix = isCompany ? "netto" : "brutto";
    const insurancePriceText = insuranceAmount != null
        ? Math.round(insuranceAmount).toLocaleString('pl-PL') + " zł " + insuranceSuffix
        : "indywidualna wycena";

    const NET_FINANCING_TYPES = ["LEASING_BUSINESS", "LEASING_LOAN"];
    const gapAmount = props.gapData ? props.gapData.oneTimePremium : null;
    const gapSuffix = NET_FINANCING_TYPES.includes(props.gapFinancingType) ? "netto" : "brutto";
    const gapPriceText = gapAmount != null
        ? Math.round(gapAmount).toLocaleString('pl-PL') + " zł " + gapSuffix
        : "indywidualna wycena";

    return (
        <Fragment>
            <div className="calc__summary-header">
                <p className="calc__summary-title">Podsumowanie</p>
                <button type="button" className="calc__summary-toggle" onClick={() => setExpanded(e => !e)}>
                    {expanded ? "Zwiń składowe" : "Rozwiń składowe"}
                    <span className={"calc__summary-arrow" + (expanded ? " calc__summary-arrow--up" : "")}>›</span>
                </button>
            </div>

            {expanded && (
                <div className="calc__summary-rows">
                    <div className="calc__summary-row">
                        <span className="calc__row-label">Okres {productNoun}</span>
                        <span className="calc__row-change" onClick={props.changeContractLength}>Zmień</span>
                        <span className="calc__row-value">{props.calculationParameters.contractLength} m-cy</span>
                    </div>
                    <div className="calc__summary-row">
                        <span className="calc__row-label">Opłata wstępna</span>
                        <span className="calc__row-change" onClick={props.changeInitialFee}>Zmień</span>
                        <span className="calc__row-value">{props.initialFeeValue} zł</span>
                    </div>
                    {!isCompany && !props.hideRrso &&
                        <div className="calc__summary-row">
                            <span className="calc__row-label"><LabelWithInfo infoCode="rrso"/></span>
                            <span className="calc__row-value">
                                {props.calculationResult.rrso != null
                                    ? props.calculationResult.rrso.toLocaleString('pl-PL')
                                    : '—'} %
                            </span>
                        </div>
                    }
                    <div className="calc__summary-row">
                        <span className="calc__row-label">Rata {productNoun}</span>
                        <span className="calc__row-value">
                            {FormatUtils.formatMoney(props.calculationResult.installment)}
                        </span>
                    </div>
                    {props.insuranceChecked && (
                        <div className="calc__summary-row">
                            <span className="calc__row-label">Ubezpieczenie OC/AC</span>
                            <span className="calc__row-value">{insurancePriceText}</span>
                        </div>
                    )}
                    {props.gapChecked && (
                        <div className="calc__summary-row">
                            <span className="calc__row-label">GAP na czas trwania umowy</span>
                            <span className="calc__row-value">{gapPriceText}</span>
                        </div>
                    )}
                </div>
            )}
        </Fragment>
    );
}

export default CreditCalculationSummary;
